import { AppRouter } from './app/router.tsx';

/**
 * The shell is the router and nothing else. Route boundaries, the account
 * state they read, and the screens behind them all live under `app/` and
 * `features/`.
 */
export function App() {
  return <AppRouter />;
}
